// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__qN8Dg","notes":"Notes_notes__3tr8T"};